import React from "react"
import { useSelector } from "react-redux"
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import TrialOperationsGoalsDashboardV2 from "./TrialOperationsGoalsDashboardV2"
import TrialOperationsPresentChartsV2 from "./ShiftChartsV2/TrialOperationsPresentChartsV2"
import IconifyIcon from "../../../components/Shared/IconifyIcon"
import { layoutModeTypes } from "../../../constants/layout"
import Colors from "../../../constants/Colors"
import overviewIcon from "../../../assets/images/icons/grommet-icons_overview.svg"

const TrialOperationsPresentStatisticsV2 = ({ filters }) => {
  const { loading, isLoading, dashboardData } = useSelector(
    state => state.Dashboard
  )
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  return (
    <>
      {loading ? (
        ""
      ) : (
        <Card>
          <CardBody>
            <Row>
              <Col lg={12}>
                <div className="d-flex align-items-center gap-2">
                  <img src={overviewIcon} alt="Overview" />
                  <h3 className="mt-2 font-bold">{t("Overview")}</h3>
                </div>
                <p
                  style={{
                    color:
                      layoutMode === layoutModeTypes.LIGHT
                        ? Colors.mutedBlue
                        : Colors.white,
                  }}
                  className="mb-4"
                >
                  {t("General Trial Operation Statistics (Present)")}
                </p>
                <Row>
                  <Col sm={3} className="mb-2">
                    <Card
                      className="rounded-4 text-center p-1"
                      style={{ border: "1px solid #D6D6D6" }}
                    >
                      <CardBody>
                        <div
                          className={
                            language !== "en" ? "text-end" : "text-start"
                          }
                        >
                          <div
                            className="fw-semibold"
                            style={{
                              fontSize: "14px",
                              color:
                                layoutMode === layoutModeTypes.LIGHT
                                  ? Colors.mutedBlue
                                  : Colors.white,
                            }}
                          >
                            <IconifyIcon
                              width={24}
                              height={24}
                              icon="solar:pen-2-line-duotone"
                              style={{
                                marginLeft: language !== "en" ? "5px" : 0,
                                marginRight: language !== "en" ? 0 : "5px",
                                color:
                                  layoutMode === layoutModeTypes.LIGHT
                                    ? "#A442FF"
                                    : Colors.primaryLight,
                              }}
                            />
                            {t("Enrolled")}
                          </div>

                          <div
                            className="h3 fw-bold mb-4"
                            style={{
                              paddingLeft: language !== "en" ? 0 : "30px",
                              paddingRight: language !== "en" ? "30px" : 0,
                              fontSize: "18px",
                              color:
                                layoutMode === layoutModeTypes.LIGHT
                                  ? Colors.primary
                                  : "white",
                            }}
                          >
                            {dashboardData?.count_trials_overview
                              ?.total_enrolled || 0}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col sm={3} className="mb-2">
                    <Card
                      className="rounded-4 text-center p-1"
                      style={{ border: "1px solid #D6D6D6" }}
                    >
                      <CardBody>
                        <div
                          className={
                            language !== "en" ? "text-end" : "text-start"
                          }
                        >
                          <div
                            className="fw-semibold"
                            style={{
                              fontSize: "14px",
                              color:
                                layoutMode === layoutModeTypes.LIGHT
                                  ? Colors.mutedBlue
                                  : Colors.white,
                            }}
                          >
                            <IconifyIcon
                              width={24}
                              height={24}
                              icon="solar:user-check-line-duotone"
                              style={{
                                marginLeft: language !== "en" ? "5px" : 0,
                                marginRight: language !== "en" ? 0 : "5px",
                                color:
                                  layoutMode === layoutModeTypes.LIGHT
                                    ? "#34A853"
                                    : "#34A853",
                              }}
                            />
                            {t("Present")}
                          </div>

                          <div
                            className="h3 fw-bold mb-4"
                            style={{
                              paddingLeft: language !== "en" ? 0 : "30px",
                              paddingRight: language !== "en" ? "30px" : 0,
                              fontSize: "18px",
                              color:
                                layoutMode === layoutModeTypes.LIGHT
                                  ? Colors.primary
                                  : "white",
                            }}
                          >
                            {dashboardData?.count_trials_overview
                              ?.total_present || 0}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col lg={12}>
                <TrialOperationsPresentChartsV2
                  shiftData={dashboardData?.shift_stats || []}
                />
              </Col>
              <Col lg={12}>
                <CardBody
                  className="rounded-4"
                  style={{ border: "1px solid #DDE3EE" }}
                >
                  <TrialOperationsGoalsDashboardV2
                    dashboardData={dashboardData}
                    filters={filters}
                  />
                </CardBody>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default TrialOperationsPresentStatisticsV2
